import { render, staticRenderFns } from "./compDetails.vue?vue&type=template&id=42ea941c&"
import script from "./compDetails.vue?vue&type=script&lang=js&"
export * from "./compDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42ea941c')) {
      api.createRecord('42ea941c', component.options)
    } else {
      api.reload('42ea941c', component.options)
    }
    module.hot.accept("./compDetails.vue?vue&type=template&id=42ea941c&", function () {
      api.rerender('42ea941c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/gehad/compDetails.vue"
export default component.exports